import React from 'react'
import Bhindi from './../../assets/img/bhindi.jpg';
import Muskmelon from './../../assets/img/muskmelon.jpg';
import Tinda from './../../assets/img/tinda.jpg';
import BottleGourd from './../../assets/img/bottlegourd.jpg';
import SpongeGourd from './../../assets/img/spongegourd.jpg';
import Cucumber from './../../assets/img/cucumber.jpg';
import Brinjal from './../../assets/img/brinjal.jpg';
import Chillies from './../../assets/img/chillies.jpg';
import BitterGourd from './../../assets/img/bittergourd.jpg';
import Tomato from './../../assets/img/tomato.jpg';
const KharifVeg = () => {
  return (
    <div className="container my-3">

    <div className="abouts">
        <h5>Kharif Crops Vegetables</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg" style={{textAlign:'justify'}}>

        <div className="row mb-1 justify-content-between">
            

            <div className="col-lg-12 mb-1">
                <h4>Muskmelon</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Muskmelon} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4">
                
                <p>Hara Madhu, Pb. Sunehri, D. Madhu Madhuras, Pusa Madhuras</p>
                </div>

            </div>
            </div>

            <div className="col-lg-12 mb-1">
                <h4>Bhindi</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Bhindi} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa Sawani, Arka Anamika, Versha Uphar, Hisar Unnat</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Tinda</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Tinda} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Arka, Ludhiyana, H-T-10</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Bottle Gourd</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={BottleGourd} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa-Summer, Prolific Long, Pb Round PSPR, Pusa Naveen</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Sponge Gourd</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={SpongeGourd} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa Chikni, Pusa Nasadar, Pusa Supriya</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Bitter Gourd</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={BitterGourd} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>C-96, Pusa-Domausmi, Coimbatore Long</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Cucumber</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Cucumber} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Poinsette</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Brinjal</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Brinjal} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa Purple Long, Pusa Purple Cluster, Pusa Kranti, BR-112, PH-4, H-8</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Chillies</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Chillies} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>NP-46-A, Pusa Jwala, G-3, CH-1</p>
                </div>

            </div>
            </div>
            <div className="col-lg-12 mb-1">
                <h4>Tomato</h4>
            <div className="row mb-1 justify-content-between">

            <div className="col-lg-4 mb-4  text-center">
            <img src={Tomato} alt="Seed Production" className="img-fluid rounded shadow-sm" />
            </div>

                <div className="col-lg-8 mb-4 ">
                
                <p>Pusa Ruby, P Early, Dwarl, Sioux, Manglobe, Roma, P. Chuhhara, HS-102, Hisar Arun</p>
                </div>

            </div>
            </div>
           
        </div>

        </div>
    </div>
  )
}

export default KharifVeg
